import React, {useEffect, useState} from 'react'
import gql from 'graphql-tag'
import {createUseStyles} from 'react-jss'
import {Link} from 'react-router-dom'

import routesHelper from '@prepler/core/lib/routesHelper'

const useStyles = createUseStyles(theme => ({
	article: {
		'& h3': {
			padding: '40px 5px 30px',
			textAlign: 'center',
			fontSize: '32px',
			fontWeight: theme.fontWeight.light
		}
	},
	ul: {
		fontSize: '0',
		'& li': {
			display: 'inline-block',
			position: 'relative',
			width: '33%',
			padding: '0 10px',
			margin: '0 0 32px',
			verticalAlign: 'top',
			listStyle: 'none',
			fontSize: '16px',
			'@media (max-width: 991px)': {
				width: 'calc(50% - 20px)'
			},
			'@media (max-width: 599px)': {
				width: 'calc(100% - 20px)'
			},
			'& a': {
				textDecoration: 'none',
				wordBreak: 'normal',
				whiteSpace: 'normal',
				'& $wrappedImage': {
					height: '0',
					paddingBottom: '31.25%',
					position: 'relative',
					// background: '#fff',
					overflow: 'hidden',
					'& > div': {
						display: 'inline-block'
					},
					'& > div, & > div img': {
						position: 'absolute',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0'
					},
					'& > div img': {
						display: 'block',
						maxHeight: '100%',
						maxWidth: '100%',
						margin: 'auto',
						borderRadius: '0',
						border: 'none',
						verticalAlign: 'middle'
					}
				},
				'& > h3': {
					fontSize: '14px',
					color: '#2c373b',
					lineHeight: '19px',
					fontWeight: theme.fontWeight.normal,
					margin: '13px 0 0',
					padding: '0px'
				}
			}
		}
	},
	wrappedImage: {}
}));

const ArticlesPopular = ({articles}) => {
	const classes = useStyles();

	const [limit, setLimit] = useState(6);
	useEffect(() => {
		const updateLimit = () => (
			setLimit([[992, 6], [600, 4], [0, 2]].find(([width, _limit]) => window.innerWidth >= width)[1])
		);
		window.addEventListener('resize', updateLimit);
		return () => window.removeEventListener('resize', updateLimit);
	});

	return articles.length > 0 ? (
		<div className={classes.article}>
			<h3>Popular Posts</h3>
			<ul className={classes.ul}>
				{articles.slice(0, limit).map(({id, slug, title, photo}) =>
					<li key={id}>
						<Link to={{pathname: routesHelper.articlePath({id: slug || id})}}>
							<div className={classes.wrappedImage}>
								<div>
									<img
										alt="" src={photo.medium}
										srcSet={`${photo.medium4} 480w, ${photo.medium8} 240w`}
									/>
								</div>
							</div>
							<h3>{title}</h3>
						</Link>
					</li>
				)}
			</ul>
		</div>
	) : null;
}

ArticlesPopular.fragments = {
	article: gql`
		fragment ArticlesPopularArticle on Article {
			id
			slug
			title
			photo {
				medium
				medium4
				medium8
			}
		}
	`,
}

export default ArticlesPopular;
